import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgModel } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ProductDetailDisplayFullComponent } from 'src/app/components/marketplace/detail-pages/product-detail-display/product-detail-display-full/product-detail-display-full.component';
import { ProductCommonFeatureInterface } from 'src/app/model/commonFeature/product-common-feature-interface';
import { ProductInterface } from 'src/app/model/products/product-interface';
import { ProductVariantInterface } from 'src/app/model/products/product-variant-interface';
import { CommonFeatureService } from 'src/app/services/common-feature-service/common-feature.service';
import { OrganisationService } from 'src/app/services/dataServices/organisation-service/organisationservice';
import { ProductService } from 'src/app/services/dataServices/product-service/productService';
import { ProductVariantService } from 'src/app/services/dataServices/product-variant-service/product-variant.service';
import { DialogService } from 'src/app/services/dialog-service/dialog-service.service';
import { UserService } from 'src/app/services/user-service/userservice';
import { UtilService } from 'src/app/services/util-service/utilService';
import { CustomTextErrorStateMatcher, MinLengthErrorStateMatcher } from "src/environments/validators";

@Component({
    selector: 'app-edit-product-variant-screen',
    templateUrl: './edit-product-variant-screen.component.html',
    styleUrls: ['./edit-product-variant-screen.component.css'],
    standalone: false
})
export class EditProductVariantScreenComponent implements OnInit, OnDestroy {
    // TODO: To be integrated into product service!!!
    productEdit: ProductInterface;
    variantEdit: ProductVariantInterface;
    variantEditName: string = '';
    variantEditComment: string = '';
    variantEditDescription: string = '';
    private isDescriptionValid: boolean = true;
    variantNameErrorStateMatcher = new MinLengthErrorStateMatcher(160);
    commonFeatures: ProductCommonFeatureInterface[] = [];
    public product?: ProductInterface;
    formTitle: string = "Variante bearbeiten";

    @ViewChild('variantNameCtrl') variantNameCtrl: NgModel;

    constructor(
        private commonFeatureService: CommonFeatureService,
        private cdr: ChangeDetectorRef,
        private dialog: MatDialog,
        public productService: ProductService,
        public router: Router,
        private route: ActivatedRoute,
        public organisationService: OrganisationService,
        private utilService: UtilService,
        private dialogService: DialogService,
        public productVariantService: ProductVariantService,
        private userService: UserService,
        private titleService: Title
    ) {
        //Reroutes to marketplace if the user is not a member of the organisation
        document.documentElement.style.setProperty('--scrollStatus', 'auto');

        if (
            !this.userService.currentMemberships.find(
                (orga) =>
                    orga.organisationId ===
                    this.organisationService.activeItem.organisationId
            )
        ) {
            this.router.navigateByUrl('/marktplatz');
        }
    }

    ngOnDestroy(): void {
        window.removeEventListener('beforeunload', this.unloadHandler);
        this.utilService.setDirty(false);
        document.documentElement.style.setProperty('--scrollStatus', 'hidden');
    }

    editVariant(): void {
        if (this.utilService.isStringNullOrEmpty(this.variantEditName)) {
            this.dialogService.openDialog(
                'Variante bearbeiten fehlgeschlagen',
                'Bitte geben Sie einen Variantennamen ein!'
            );
            return;
        }

        if (
            !UtilService.areStringsValid(
                this.variantEditName,
                this.variantEditDescription
            )
        ) {
            this.dialogService.openDialog(
                'Variante bearbeiten fehlgeschlagen',
                'Der Name oder die Beschreibung sind zu lang.'
            );
            return;
        }

        let variant: ProductVariantInterface =
            this.productEdit.productVariants.find(
                (variant) => variant.id === this.variantEdit.id
            );
        variant.name = this.variantEditName;
        variant.comment = this.variantEditComment;
        variant.description = this.variantEditDescription;
        this.productVariantService.ITEM_MAP[':organisationId'] = String(
            this.productService.activeItem.company
        );

        this.productVariantService
            .putItem(variant)
            .then((v) => {
                let url = '/organisations/' + this.organisationService.activeItem.organisationId +
                    '/products/' + this.productService.activeItem.id;
                this.router.navigateByUrl(url);
                this.dialogService.openDialog(
                    'Variant bearbeitet',
                    'Die Variante ' + v.name + ' wurde erfolgreich bearbeitet.'
                );
                window.removeEventListener('beforeunload', this.unloadHandler);
                this.utilService.setDirty(false);
            })
            .catch((e) => { });
    }

    cancelVariantEdit(): void {
        window.removeEventListener('beforeunload', this.unloadHandler);
        this.utilService.setDirty(false);
        this.router.navigate([
            '/organisations/' +
            this.organisationService.activeItem.organisationId +
            '/products/' +
            this.productService.activeItem.id

        ]);
    }

    ngOnInit(): void {
        window.addEventListener('beforeunload', this.unloadHandler);
        this.utilService.setDirty(true);
        this.productEdit = this.productService.activeItem;
        this.titleService.setTitle(
            this.productService.activeItem.name +
            ': Variante bearbeiten - BIMSWARM'
        );
        this.variantEdit = this.productEdit.productVariants.find(
            (variant) =>
                variant.id ===
                parseInt(this.route.snapshot.paramMap.get('variantId'))
        );
        this.variantEditName = this.variantEdit.name;
        this.variantEditDescription = this.variantEdit.description;
        this.variantEditComment = this.variantEdit.comment;
    }

    private unloadHandler = (event: BeforeUnloadEvent) => {
        if (this.hasPendingChanges()) {
            event.preventDefault();
            event.returnValue = ''; // required for Chrome
        }
    };

    hasPendingChanges(): boolean {
        return this.utilService.isDirty();
    }

    public onDescriptionValidityChange(descriptionValid: boolean): void {
        this.isDescriptionValid = descriptionValid;
    }

    async openProductDetailsPageDialog(
        title: string
    ): Promise<Observable<any>> {
        this.commonFeatureService
            .getFeaturesForProduct(this.productService.activeProduct.id)
            .subscribe((success) => {
                this.commonFeatures = success;
                this.cdr.detectChanges();
            });
        this.productService.activeProduct.productVariants.forEach((v, pvIndex) => {
            if (v.id == this.variantEdit.id) {
                this.productEdit.productVariants[pvIndex] = this.variantEdit;
            }
        });
        const reference = this.dialog.open(ProductDetailDisplayFullComponent, {
            width: '95vw',
            maxWidth: '95vw',
            height: '90vh',
            data: {
                title: 'Produktübersicht',
                product: this.productEdit,
                preview: true,
                commonFeatures: this.commonFeatures
            }
        });
        return reference.afterClosed();
    }

    isVariantVersionStepComplete(): boolean {
        return this.variantNameCtrl?.valid === true &&
            this.variantNameCtrl.value?.length <= 160 &&
            this.isDescriptionValid
    }
}
